// extracted by mini-css-extract-plugin
export default {"Back":"Back_Back__l+TT-","BackIcon":"Back_BackIcon__0xrm5"};